import { setCookie } from 'cookies-next'
import { nextLocaleCookieKey, nextLocaleCookieMagAge } from './init-language-cookie'

export function setLanguageCookie(locale: string) {
  setCookie(nextLocaleCookieKey, locale, { maxAge: nextLocaleCookieMagAge })
}
